import dayjs from "dayjs";

const trackerDummyData = [
  {
    dateTime: '2026-03-26T14:46:56.036Z',
    status: 'Successful',
    content: <span>You have been successful in your application for the position titled <span className="text-blue-400">Senior Node.js Developer</span></span>
  },
  {
    dateTime: '2026-03-24T04:46:56.036Z',
    status: 'Offer Accepted',
    content: <span>An offer has been accepted by you from <span className="text-blue-400">ABC Recruitment</span> on behalf of the hiring company for the position titled <span className="text-blue-400">Senior Node.js Developer</span></span>
  },
  {
    dateTime: '2026-03-26T14:46:56.036Z',
    status: 'Interview',
    content: <span>An interview has been scheduled for <span className="text-blue-400">4:00 pm Friday 18th March 2026</span> with the hiring company at 123 High Street London</span>
  },
  {
    dateTime: '2026-03-24T04:46:56.036Z',
    status: 'Shortlisted',
    content: <span>Your application for the position of <span className="text-blue-400">Senior Node.js Developer</span> has been shortlisted by the hiring company.</span>
  },
  {
    dateTime: '2026-03-26T14:46:56.036Z',
    status: 'Application Viewed',
    content: <span>The hiring company has viewed your application submitted for the position of <span className="text-blue-400">Senior Node.js Developer</span> by <span className="text-blue-400">ABC Recruitment</span></span>
  },
  {
    dateTime: '2026-03-24T04:46:56.036Z',
    status: 'Submitted',
    content: <span>Your application for the position of <span className="text-blue-400">Senior Node.js Developer</span> has been submitted by <span className="text-blue-500">ABC Recruitment</span> to the hiring company</span>
  },
  {
    dateTime: '2026-03-24T04:46:56.036Z',
    status: 'Meeting',
    content: <span>A phone call meeting has been scheduled at <span className="text-blue-400">4:00pm Friday 18th March 2026</span> with <span className="text-blue-500">ABC Recruitment</span></span>
  },
  {
    dateTime: '2026-03-24T04:46:56.036Z',
    status: 'Applied',
    content: <span>You applied for the position titled <span className="text-blue-400">Senior Node.js Developer</span> posted by <span className="text-blue-500">ABC Recruitment</span></span>
  },

]


const Card = ({ data }) => {
  return <div className="grid grid-cols-[0.4fr_1.6fr] gap-12 items-center">
    <div className="flex flex-col gap-1.5">
      <span className="text-xss font-semibold text-charcoal">{dayjs(data?.dateTime).format('hh:mm a')}</span>
      <span className="text-xss text-light-black">{dayjs(data?.dateTime).format('ddd Do')}  {dayjs(data?.dateTime).format('MMMM YYYY')}</span>
      <div className="flex border-l-3 font-semibold text-charcoal text-xss border-l-[3px] border-l-blue-400 border rounded-sm px-2 py-0.5">{data?.status}</div>
    </div>
    <div className=" flex flex-col justify-center text-xss font-medium text-charcoal border-b h-28 leading-6">{data?.content}</div>
  </div>
};

const CandidateTrackerPageStatic = () => {
  return (
    <div className="flex flex-col flex-1 min-h-0 rounded-md bg-white pt-7">
      <span className="font-bold text-charcoal mx-auto">Activity Tracker</span>

      {/* Tracker List */}
      <div className="flex flex-col min-h-0 my-5 w-[70%] mx-auto overflow-y-scroll no-scrollbar">
        {
          trackerDummyData?.map((item) => {
            return <Card data={item} />
          })
        }

      </div>
    </div>
  );
};

export default CandidateTrackerPageStatic;